import React, { useEffect, useRef } from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
import CloseRounded from '@mui/icons-material/CloseRounded';
import { Divider, IconButton } from '@mui/material';
import { convertToReadable } from '../../../helpers';
import { isFalsy } from '../../../utils/common';
var ScholarshipOverview = function (_a) {
    var scholarshipDescription = _a.scholarshipDescription, scholarshipName = _a.scholarshipName;
    var containerRef = useRef(null);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (containerRef.current && !containerRef.current.shadowRoot) {
            ((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.attachShadow({
                mode: 'open'
            })) || {};
        }
        if ((_c = (_b = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.innerHTML) {
            containerRef.current.shadowRoot.innerHTML = '';
        }
        var headerDiv = document.createElement('div');
        headerDiv.innerHTML = scholarshipDescription !== null && scholarshipDescription !== void 0 ? scholarshipDescription : '';
        (_e = (_d = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _d === void 0 ? void 0 : _d.shadowRoot) === null || _e === void 0 ? void 0 : _e.appendChild(headerDiv);
    }, [scholarshipDescription]);
    if (!scholarshipName && !scholarshipDescription)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-y-2" },
            scholarshipName ? (React.createElement(GBTypography, { variant: "h2Regular", className: "lfc-text-grey-900" }, scholarshipName)) : null,
            scholarshipDescription ? React.createElement("div", { ref: containerRef }) : null),
        React.createElement(Divider, { className: "lfc-border-dashed lfc-border-gbTokens-grey-A500 lfc-my-4" })));
};
var ScholarshipIntake = function (_a) {
    var _b, _c;
    var scholarshipIntake = _a.scholarshipIntake;
    if (isFalsy(scholarshipIntake))
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-y-2" },
            React.createElement(GBTypography, { variant: "caption1Semibold" }, "Scholarship Intake"),
            React.createElement(GBTypography, { variant: "body4", className: "lfc-text-gbTokens-grey-100" }, (_c = (_b = (scholarshipIntake !== null && scholarshipIntake !== void 0 ? scholarshipIntake : [])) === null || _b === void 0 ? void 0 : _b.map(function (intake) { return convertToReadable(intake); })) === null || _c === void 0 ? void 0 : _c.join(', '))),
        React.createElement(Divider, { className: "lfc-border-dashed lfc-border-gbTokens-grey-A500 lfc-my-4" })));
};
var ScholarshipAmount = function (_a) {
    var scholarshipAmount = _a.scholarshipAmount;
    if (isFalsy(scholarshipAmount))
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-y-2" },
            React.createElement(GBTypography, { variant: "caption1Semibold" }, "Total Amount"),
            React.createElement(GBTypography, { variant: "body4", className: "lfc-text-gbTokens-grey-100" }, scholarshipAmount)),
        React.createElement(Divider, { className: "lfc-border-dashed lfc-border-gbTokens-grey-A500 lfc-my-4" })));
};
var ScholarshipStepsToApply = function (_a) {
    var howToApply = _a.howToApply;
    var containerRef = useRef(null);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (containerRef.current && !containerRef.current.shadowRoot) {
            ((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.attachShadow({
                mode: 'open'
            })) || {};
        }
        if ((_c = (_b = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.innerHTML) {
            containerRef.current.shadowRoot.innerHTML = '';
        }
        var headerDiv = document.createElement('div');
        headerDiv.innerHTML = howToApply !== null && howToApply !== void 0 ? howToApply : '';
        (_e = (_d = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _d === void 0 ? void 0 : _d.shadowRoot) === null || _e === void 0 ? void 0 : _e.appendChild(headerDiv);
    }, [howToApply]);
    if (!howToApply)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-y-2" },
            React.createElement(GBTypography, { variant: "caption1Semibold" }, "How to Apply?"),
            React.createElement("div", { ref: containerRef })),
        React.createElement(Divider, { className: "lfc-border-dashed lfc-border-gbTokens-grey-A500 lfc-my-4" })));
};
var ScholarshipCriteria = function (_a) {
    var scholarshipCriteria = _a.scholarshipCriteria;
    if (!scholarshipCriteria)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-y-2" },
            React.createElement(GBTypography, { variant: "caption1Semibold" }, "Criteria"),
            React.createElement(GBTypography, { variant: "body4", className: "lfc-text-gbTokens-grey-100" }, scholarshipCriteria)),
        React.createElement(Divider, { className: "lfc-border-dashed lfc-border-gbTokens-grey-A500 lfc-my-4" })));
};
var ScholarshipAwardedAs = function (_a) {
    var scholarshipAwardedAs = _a.scholarshipAwardedAs;
    if (!scholarshipAwardedAs)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-y-2" },
            React.createElement(GBTypography, { variant: "caption1Semibold" }, "Awarded as"),
            React.createElement(GBTypography, { variant: "body4", className: "lfc-text-gbTokens-grey-100" }, scholarshipAwardedAs)),
        React.createElement(Divider, { className: "lfc-border-dashed lfc-border-gbTokens-grey-A500 lfc-my-4" })));
};
var ScholarshipDeadline = function (_a) {
    var scholarshipDeadline = _a.scholarshipDeadline;
    if (!scholarshipDeadline)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-y-2" },
            React.createElement(GBTypography, { variant: "caption1Semibold" }, "Deadline"),
            React.createElement(GBTypography, { variant: "body4", className: "lfc-text-gbTokens-grey-100" }, scholarshipDeadline)),
        React.createElement(Divider, { className: "lfc-border-dashed lfc-border-gbTokens-grey-A500 lfc-my-4" })));
};
var ScholarshipEligibility = function (_a) {
    var scholarshipEligibility = _a.scholarshipEligibility;
    var containerRef = useRef(null);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (containerRef.current && !containerRef.current.shadowRoot) {
            ((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.attachShadow({
                mode: 'open'
            })) || {};
        }
        if ((_c = (_b = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.innerHTML) {
            containerRef.current.shadowRoot.innerHTML = '';
        }
        var headerDiv = document.createElement('div');
        headerDiv.innerHTML = scholarshipEligibility !== null && scholarshipEligibility !== void 0 ? scholarshipEligibility : '';
        (_e = (_d = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _d === void 0 ? void 0 : _d.shadowRoot) === null || _e === void 0 ? void 0 : _e.appendChild(headerDiv);
    }, [scholarshipEligibility]);
    if (!scholarshipEligibility)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-y-2" },
            React.createElement(GBTypography, { variant: "caption1Semibold" }, "Eligibility"),
            React.createElement("div", { ref: containerRef })),
        React.createElement(Divider, { className: "lfc-border-dashed lfc-border-gbTokens-grey-A500 lfc-my-4" })));
};
var ScholarshipDetailsSection = function (_a) {
    var scholarshipData = _a.scholarshipData, onClose = _a.onClose;
    return (React.createElement("div", null,
        React.createElement("div", { className: "lfc-bg-gbTokens-grey-A200 lfc-flex lfc-justify-between lfc-items-center lfc-border-b lfc-border-gbTokens-grey-A500 lfc-p-4 lfc-sticky lfc-top-0 lfc-rounded-t-lg" },
            React.createElement(GBTypography, { variant: "sh1Semibold" }, "Scholarship Details"),
            React.createElement(IconButton, { onClick: onClose },
                React.createElement(CloseRounded, { className: "lfc-text-gbTokens-grey-A900" }))),
        React.createElement("div", { className: "lfc-px-4 lfc-py-6 lfc-w-full lfc-break-words" },
            React.createElement(ScholarshipOverview, { scholarshipName: scholarshipData === null || scholarshipData === void 0 ? void 0 : scholarshipData.scholarshipName, scholarshipDescription: scholarshipData === null || scholarshipData === void 0 ? void 0 : scholarshipData.scholarshipDescription }),
            React.createElement(ScholarshipIntake, { scholarshipIntake: scholarshipData === null || scholarshipData === void 0 ? void 0 : scholarshipData.scholarshipIntake }),
            React.createElement(ScholarshipAmount, { scholarshipAmount: scholarshipData === null || scholarshipData === void 0 ? void 0 : scholarshipData.scholarshipAmount }),
            React.createElement(ScholarshipStepsToApply, { howToApply: scholarshipData === null || scholarshipData === void 0 ? void 0 : scholarshipData.howToApply }),
            React.createElement(ScholarshipCriteria, { scholarshipCriteria: scholarshipData === null || scholarshipData === void 0 ? void 0 : scholarshipData.scholarshipCriteria }),
            React.createElement(ScholarshipAwardedAs, { scholarshipAwardedAs: scholarshipData === null || scholarshipData === void 0 ? void 0 : scholarshipData.scholarshipAwardedAs }),
            React.createElement(ScholarshipDeadline, { scholarshipDeadline: scholarshipData === null || scholarshipData === void 0 ? void 0 : scholarshipData.scholarshipDeadline }),
            React.createElement(ScholarshipEligibility, { scholarshipEligibility: scholarshipData === null || scholarshipData === void 0 ? void 0 : scholarshipData.scholarshipEligibility }))));
};
export default ScholarshipDetailsSection;
//# sourceMappingURL=ScholarshipDetailsSection.js.map